import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

const Bolg = () => {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      const querySnapshot = await getDocs(collection(db, "blogs"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const sortedData = data.sort(
        (a, b) => b.createdAt?.seconds - a.createdAt?.seconds
      );
      setBlogs(sortedData);
    };
    fetchBlogs();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "—";
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString("ar-EG", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="bolg" id="blog">
      <div className="mainTitle">
        <div className="lines">
          <div className="line"></div>
          <div className="line"></div>
          <div className="title">
            <h2>المدونة</h2>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="mainContent">
          <div className="blogs">
            {blogs.map((item) => (
              <div className="blogCard" key={item.id}>
                <img src={item.imageUrl} alt={item.title} />
                <h2>{item.title}</h2>
                <p className="date">{formatDate(item.createdAt)}</p>
                <button onClick={() => navigate(`/blog/${item.id}`)}>
                  عرض المقالة
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bolg;
